export enum RetentionResourceType {
  ROOM = 'room',
  SESSION = 'session',
  FILE = 'file',
  AUDIT_LOG = 'audit_log',
  DOCUMENT = 'document',
}

export enum RetentionRuleType {
  TTL = 'ttl',
  EVENT = 'event',
  ZERO = 'zero',
}

export type EventRetentionRuleConfig = {
  name: string
}

export interface EventRetentionRule extends RetentionRule {
  config: EventRetentionRuleConfig
}

export type TTLRetentionRuleConfig = {
  value: number
  unit: string
}

export interface TTLRetentionRule extends RetentionRule {
  config: TTLRetentionRuleConfig
}

export interface ZeroDataRetentionRule extends RetentionRule {
  type: RetentionRuleType.ZERO
}

export type RoomRetentionConfig = Record<string, never>

export type SessionRetentionConfig = {
  kind?: string | null
  source?: string | null
}

export type FileRetentionConfig = {
  kind?: string | null
}

export type AuditLogRetentionConfig = {
  kind?: string | null
  defaultEnabled?: boolean | null
}

export interface RoomRetention extends RetentionResource {
  config?: RoomRetentionConfig | null
}

export interface SessionRetention extends RetentionResource {
  config?: SessionRetentionConfig | null
}

export interface FileRetention extends RetentionResource {
  config?: FileRetentionConfig | null
}

export interface AuditLogRetention extends RetentionResource {
  config?: AuditLogRetentionConfig | null
}

export interface RetentionResource {
  type: RetentionResourceType
}

export interface RetentionRule {
  type: RetentionRuleType
}

export type RetentionPolicy = {
  id: string
  enterprise: boolean
  rule: RetentionRule
  resource: RetentionResource
  createdAt: string
  updatedAt: string
  isDefault: boolean
}
